<div class="layout-submenu-content">
    <ng-content></ng-content>
</div>